import script from "./TotalExpenditure.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalExpenditure.vue?vue&type=script&setup=true&lang=js"

import "./TotalExpenditure.vue?vue&type=style&index=0&id=4b68356f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b68356f"]])

export default __exports__